import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

export default function SlideDown({ targetRef, start, duration = 0.5, distance = -7 }) {
  const progressRef = useRef(0);

  useFrame((_, delta) => {
    if (!start || !targetRef.current) return;
    if (progressRef.current >= 1) return;

    const next = Math.min(1, progressRef.current + delta / duration);
    const eased = next * next * (3 - 2 * next); // smoothstep
    targetRef.current.position.y = THREE.MathUtils.lerp(0, distance, eased);
    progressRef.current = next;
  });

  return null; // headless updater
}
